import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import {BASENAME} from '../../constants';
import '../App.css';

import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import { trackPromise} from 'react-promise-tracker';

import CanvasUserTable from './CanvasUserTable';

const PER_PAGE = 10;

const styles = theme => ({
    root: {
        // width: '100%',
        marginTop: '10px',
        overflowX: 'auto',
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: 400,
    },
    table: {
        // minWidth: 700,
    },
    input: {
        marginLeft: 8,
        flex: 1,
    },
    iconButton: {
        padding: 10,
    },
    divider: {
        width: 1,
        height: 28,
        margin: 4,
    },

});

class SearchCanvasUsers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchTerm: '',
            page: 1,
            prevPage: null,
            nextPage: null,
            departments:['Loading departments...'],
            departmentsLoading: true,
        };
    }

    onSuccess = ({canvasUsers, page, prev_page, next_page}) => {
        canvasUsers.forEach(canvasUser => this.props.addCanvasUser(canvasUser));
        this.setState({
            page: page,
            prevPage: prev_page,
            nextPage: next_page,
        });
    };

    onError = (err) => {
        this.setState({
            prevPage: null,
            nextPage: null,
        });
        // handle error here
        console.log(err);
    };

    handleSearchCanvasUsers = (page) => async (event) => {
        event.preventDefault();
        try {
            const {users, prev_page, next_page} = await this.fetchCanvasUsers(this.state.searchTerm, page);
            if (Array.isArray(users)) {
                this.props.resetCanvasUsers();
                // remove any users that were already added to reviewers
                const filteredCanvasUsers = this.props.filterCanvasUsers(users);
                this.onSuccess({canvasUsers: filteredCanvasUsers, page, prev_page, next_page});
            } else {
                this.onError('Not an array error: \n' + JSON.stringify(users));
            }

        } catch (err) {
            this.onError(err);
        }
    };

    handleSearchTermChange = (event) => {
        this.setState({searchTerm: event.target.value});
    };

    fetchCanvasUsers = async (searchTerm, page = 1) => {
        const res = await trackPromise(fetch(BASENAME + '/api/search_canvas_users/' + searchTerm + "?page=" + page + "&per_page=" + PER_PAGE));
        const {users, prev_page, next_page} = await res.json();
        return {users, prev_page, next_page};
    };

    onUserSelection = (unid, department) => {
        const selectedCanvasUserIndex = this.props.canvasUsers.map(canvasUser => canvasUser.unid).indexOf(unid);
        const selectedCanvasUser = this.props.canvasUsers[selectedCanvasUserIndex];
        if(department){
            selectedCanvasUser.departments = department;
        }
        this.props.onUserSelection(selectedCanvasUser);
    };


    renderPaginationButtons() {
        const prev = this.state.prevPage ?
            <button type="button" onClick={this.handleSearchCanvasUsers(this.state.prevPage)}>Prev</button> : null;
        const next = this.state.nextPage ?
            <button type="button" onClick={this.handleSearchCanvasUsers(this.state.nextPage)}>Next</button> : null;
        return (
            <div className='prevNext'>
                <div className="button">{prev}</div>
                <div className="button">{next}</div>
            </div>
        );
    }

    componentDidMount(){
        //initial department fetch for list render when selecting a user
        fetch(BASENAME + '/api/departments/undefined')
            .then(res=>res.json())
            .then(data=>{
                this.setState({
                    departments: data,
                    departmentsLoading: false,
                })
            })
            .catch(err => {
                console.error('Failed to load departments:', err);
                this.setState({
                    departments: [],
                    departmentsLoading: false
                });
            });
    }

    render() {
        const didFoundUsers = this.props.canvasUsers && this.props.canvasUsers.length > 0;
        let visible = null;
        if (didFoundUsers && !this.state.departmentsLoading) {
            visible = (
                <div>
                    <CanvasUserTable addType={this.props.addType} departments = {this.state.departments} users={this.props.canvasUsers} onUserSelection={this.onUserSelection}>
                        {this.props.children}
                    </CanvasUserTable>
                    {this.renderPaginationButtons()}
                </div>
            )
        }

        return (
            <div>
                <form onSubmit={this.handleSearchCanvasUsers("1")}>
                    <Paper className={this.props.classes.root} elevation={1}>
                        <InputBase className={this.props.classes.input} placeholder="Search Canvas Users..." onChange={this.handleSearchTermChange}/>
                        <IconButton className={this.props.classes.iconButton} aria-label="Search" onClick={this.handleSearchCanvasUsers("1")}>
                            <SearchIcon />
                        </IconButton>
                    </Paper>
                </form>
                <br/>
                {visible}
            </div>
        )
    }
}

SearchCanvasUsers.propTypes = {
    canvasUsers: PropTypes.arrayOf(
        PropTypes.shape({
            unid: PropTypes.string.isRequired,
            name: PropTypes.string
        })
    ),
    onUserSelection: PropTypes.func,
    addCanvasUser: PropTypes.func,
    resetCanvasUsers: PropTypes.func,
    filterCanvasUsers: PropTypes.func
};

export default withStyles(styles)(SearchCanvasUsers);
